import React, {Component} from 'react';
import {Input, InputGroupAddon, InputGroupText} from 'reactstrap';
import {ChromePicker} from 'react-color';

function parseProps(props) {
    return {
        condition: {},
    };
}

export class ColorRow extends Component {
    constructor(props) {
        super(props);
        this.state = parseProps(props);
        this.onToggleBoolean = this.onToggleBoolean.bind(this);
        // this.refFocusColorWrapper = this.refFocusColorWrapper.bind(this);
    }

    onToggleBoolean(name, hardBool) {
        const state = this.state;
        let condition = {...state.condition};
        condition[name] =
            hardBool === 'true' || hardBool === 'false'
                ? hardBool === 'true'
                : !state.condition[name];
        this.setState({
            condition: condition
        });
    };

    onChangeSettingsColor(color, name, condition_name_is_rgba) {
        const props = this.props,
            state = this.state,
            is_rgba = state.condition[condition_name_is_rgba] || false,
            rgb = color.rgb,
            color_css = (
                (is_rgba ? 'rgba' : 'rgb')
                + '(' + rgb.r + ','
                + rgb.g + ','
                + rgb.b
                + (is_rgba ? (',' + rgb.a) : '')
                + ')'
            );
        props.onChangeSettingsByNameValue(name, color_css);
    };

    // refFocusColorWrapper(wrapper) {
    //     if (wrapper)
    //         wrapper.focus()
    // }

    render() {
        const props = this.props,
            state = this.state,
            value = props.value,
            line = props.line,
            is_setting_val_none = value === 'none',
            property_name = line.property_name,
            name_color_rgba = property_name + '_color_rgba',
            is_color_rgba = !!state.condition[name_color_rgba],
            name_color_open = property_name + '_color_show',
            is_color_open = !!state.condition[name_color_open];
        let rows = [];

        rows.push(
            <InputGroupAddon
                key={1}
                addonType="prepend"
            >
                <InputGroupText
                    className={'text-center pointer-no-select'}
                    style={{
                        [line.color_style]: value,
                        zIndex: 0
                    }}
                    onClick={() => {
                        this.onToggleBoolean(name_color_open);
                    }}
                >
                    {
                        line.color_style === 'background' || line.color_style === 'borderColor'
                            ? '   '
                            : line.color_style === 'color'
                            ? 'Abc'
                            : '   '
                    }
                </InputGroupText>
            </InputGroupAddon>
        );
        if (is_color_open)
            rows.push(
                <InputGroupAddon
                    key={2}
                    addonType="prepend"
                    className="position-relative"
                >
                    <div
                        /*tabIndex={-1}
                        ref={this.refFocusColorWrapper}
                        onBlur={() => {
                            this.onToggleBoolean(name_color_open, !is_color_open ? 'false' : null)
                        }}*/
                        className={'chrome-picker-wrapper position-absolute' + (!is_color_rgba ? ' color-picker-no-rgba' : '')}
                    >
                        <ChromePicker
                            color={value}
                            onChangeComplete={(color) => this.onChangeSettingsColor(color, property_name, name_color_rgba)}
                        />
                    </div>
                </InputGroupAddon>
            );
        rows.push(
            <InputGroupAddon
                key={3}
                addonType="prepend"
            >
                <InputGroupText
                    className={'pointer-no-select'
                    + (!is_setting_val_none && !is_color_rgba ? ' bg-dark text-white' : '')}
                    onClick={() => {
                        if (line.color_style === 'background' && is_setting_val_none)
                            props.onChangeSettingsByNameValue(property_name, 'rgb(0,0,0)');
                        this.onToggleBoolean(name_color_rgba, 'false');
                    }}
                >
                    {'rgb'}
                </InputGroupText>
            </InputGroupAddon>
        );
        rows.push(
            <InputGroupAddon
                key={4}
                addonType="append"
            >
                <InputGroupText
                    className={'pointer-no-select'
                    + (!is_setting_val_none && is_color_rgba ? ' bg-dark text-white' : '')}
                    onClick={() => {
                        if (line.color_style === 'background' && is_setting_val_none)
                            props.onChangeSettingsByNameValue(property_name, 'rgba(0,0,0,1)');
                        this.onToggleBoolean(name_color_rgba, 'true');
                    }}
                >
                    {'rgba'}
                </InputGroupText>
            </InputGroupAddon>
        );
        if (line.color_style === 'background')
            rows.push(
                <InputGroupAddon
                    key={5}
                    addonType="prepend"
                >
                    <InputGroupText
                        className={'pointer-no-select'
                        + (is_setting_val_none ? ' bg-dark text-white' : '')}
                        onClick={() => {
                            props.onChangeSettingsByNameValue(property_name, 'none');
                        }}
                    >
                        {'none'}
                    </InputGroupText>
                </InputGroupAddon>
            );
        if (line.color_style === 'background')
            rows.push(
                <InputGroupAddon
                    key={6}
                    addonType="prepend"
                    className={line.color_style === 'background' ? 'flex-1-1-auto' : ''}
                >
                    <Input
                        value={value}
                        className={''
                        + (is_setting_val_none ? ' ' : '')}
                        onChange={(e) => {
                            props.onChangeSettingsByNameValue(property_name, e.target.value);
                        }}
                    />
                </InputGroupAddon>
            );
        return rows;
    }
}